import InfoIcon from "../../../../../Components/Icon-SVG/InfoIcon";

import "./styles.scss";

const DetailButton = ({ onClick, title = "Show details" }) => {
  return (
    <button
      type="button"
      className="thunter-detail-button"
      title={title}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}>
      <InfoIcon width={12} height={12} color="var(--details-text-color)" />
    </button>
  );
};

export default DetailButton;
